<template>
  <div class="titulo_aviso_detalhe">
    <a target="_blank">
      <img class="pdf_icon" 
        src="https://www.uma.pt/wp-content/themes/uma/images/avisos_icon3.png">
    </a>
    <h1>{{ title }}</h1>
  </div>
</template>

<script>
export default {
  props:["title"]
}
</script>

<style lang="scss" scoped>
a{
  padding-top: 7px;
}

.titulo_aviso_detalhe {
  display: flex;
}

.titulo_aviso_detalhe img {
  width: 45px;
  margin-top: 42px;
  margin-right: 15px;
}

h1 {
  font-family: "Montserrat Bold" !important;
  font-size: 24px !important;
  padding-bottom: 10px !important;
  margin-top: 54px !important;
  color: #6eb7ec !important;
}

@media (max-width: 767px) {
  .titulo_aviso_detalhe img {
    width: 38px !important;
    margin-left: 16px;
    margin-top: 15px !important;
  }

  h1 {
    margin-left: 15px;
    font-size: 19px !important;
    margin-top: 27px !important;
  }
}
</style>